var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _g2, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg500(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 304,
    viewBox: "0 0 392 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.2 277.301H270.5V277.501H279.2V277.301Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M363.8 265.301H344.6V265.501H363.8V265.301Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 266.9H43.7V267.2H0.5",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9001 266.9H52.6001V267.1H58.9001V266.9Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.2 271.199H79.5V271.399H173.2V271.199Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.8 36.1992L182 38.9993H185.5L183.5 42.9993L186 43.9993L185 46.9993L187 47.9993L186.5 50.9993L189 47.4993L187.5 46.4993L189.5 42.9993L187 41.4993L191.336 36.1992H368.9V51.1992H17.2002V36.1992H184.8Z",
    fill: "url(#paint0_linear_1945_3664)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M369.4 34.6992H366V52.8992H369.4V34.6992Z",
    fill: "url(#paint1_linear_1945_3664)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253.1 34.6992H249.7V52.8992H253.1V34.6992Z",
    fill: "url(#paint2_linear_1945_3664)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.8 34.6992H133.4V52.8992H136.8V34.6992Z",
    fill: "url(#paint3_linear_1945_3664)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2002 34.6992H20.6002V52.7992H17.2002",
    fill: "url(#paint4_linear_1945_3664)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.054 3.61444C321.998 7.5587 321.998 13.9536 318.054 17.8979C316.59 19.3617 314.788 20.2823 312.9 20.6596V34.7003H322.6V52.9003H299V34.7003H308.9V20.6548C307.02 20.2745 305.228 19.3555 303.77 17.8979C299.826 13.9536 299.826 7.5587 303.77 3.61444C307.714 -0.329814 314.109 -0.329814 318.054 3.61444Z",
    fill: "url(#paint5_linear_1945_3664)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M318 10.7996C318 14.7996 314.8 17.9996 310.8 17.9996C306.8 17.9996 303.6 14.7996 303.6 10.7996C303.6 6.79961 306.8 3.59961 310.8 3.59961C314.8 3.59961 318 6.79961 318 10.7996Z",
    fill: "#F36D32"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17 66H368.7V81H17",
    fill: "url(#paint6_linear_1945_3664)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M369.4 64.6992H366V82.8992H369.4V64.6992Z",
    fill: "url(#paint7_linear_1945_3664)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M253.1 64.6992H249.7V82.8992H253.1V64.6992Z",
    fill: "url(#paint8_linear_1945_3664)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.8 64.6992H133.4V82.8992H136.8V64.6992Z",
    fill: "url(#paint9_linear_1945_3664)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2002 64.6992H20.6002V82.7992H17.2002",
    fill: "url(#paint10_linear_1945_3664)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1945_3664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 111.9H267.6C280.7 111.9 291.4 122.6 291.4 135.7V258.3H306.4V135.6C306.4 114.3 289.1 97 267.8 97H17",
    fill: "url(#paint11_linear_1945_3664)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M253.1 95.6992H249.7V113.899H253.1V95.6992Z",
    fill: "url(#paint12_linear_1945_3664)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.8 95.6992H133.4V113.899H136.8V95.6992Z",
    fill: "url(#paint13_linear_1945_3664)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2002 95.6992H20.6002V113.799H17.2002",
    fill: "url(#paint14_linear_1945_3664)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M308.19 259.125V255.725H289.99V259.125H308.19Z",
    fill: "#E0E0E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M308.126 153.861V150.461H289.926V153.861H308.126Z",
    fill: "url(#paint15_linear_1945_3664)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1001 292.3C4.1001 286 90.9001 281 198 281C305.1 281 391.9 286.1 391.9 292.3C391.9 298.6 305.1 303.6 198 303.6C90.9001 303.6 4.1001 298.5 4.1001 292.3Z",
    fill: "#F6F6FA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 289.8H381.4C381.4 289.8 381.5 289.4 381.5 288.9C380 288.3 378.8 287.3 378.2 286C377.2 285.8 376.7 285.8 375.4 285.6C374.5 285.5 373.7 284.7 373.3 283.8C370.8 281.9 369.1 278.5 367.6 276.4C366.6 276.2 365.6 276 364.7 275.7C364.7 275.7 364.7 275.7 364.6 275.7C363.1 276.6 361.5 277.2 359.6 277C357.7 276.9 355.7 275 356.5 272.9C357.3 271 358.4 269.4 360.6 268.9C361.4 268.7 362.2 268.8 363 268.7C363.1 268.7 363.2 268.7 363.3 268.7C363.3 268.7 363.3 268.7 363.4 268.6C363.3 268.6 363.1 268.8 363.2 268.5C364 267.2 365.3 266.8 366.4 267C370.4 265.6 372.1 265.7 372.1 261.4C372.1 260.8 372.2 260.2 372.4 259.6C372.4 259 372.4 258.5 372.4 257.9C372.5 255.9 373.9 252.4 373.1 251C372.1 249.4 369.6 248.3 368.4 246.5C368.3 246.4 368.3 246.2 368.2 246.1C367.3 245.9 366.4 245.4 365.7 244.8C364.8 245.1 363.7 244.9 362.8 243.9L361.2 243.6C360.7 243.9 360.1 244 359.5 244C358.2 245.8 355.2 246.5 354 244C351.9 239.5 353.1 233.6 359.2 234.4C359.9 234.5 360.6 234.8 361.2 235.2C362.2 235.1 363.3 235.2 364.3 235.4C365 235 365.9 234.7 366.7 234.7H370.6C370.6 234.6 370.6 234.5 370.7 234.4C370.9 232.8 370.7 231 370.7 229.4C370.7 227 370.7 224.4 371.7 222.2C371.6 221.9 371.5 221.7 371.4 221.5C367.3 220.7 360 221.1 358.3 220.7C357.2 220.4 356.6 219.8 356.3 219.1C355.9 218.7 355.5 218.2 355.3 217.7C354.8 216.4 354.5 215.1 354.4 213.7C354.3 212.7 355.1 211.3 356 210.9C356.5 210.7 357 210.4 357.5 210.3C358.1 209.6 358.8 209.1 359.6 208.7C360.4 207.8 361.6 207.2 363.1 207.2H363.4C364.5 206.8 365.6 206.2 366.6 205.4C368.2 204.1 369.6 202.5 371.9 202.8H372V190.8C365.8 190.7 359.5 188.7 355.9 183.3C354.6 181.3 355.8 179.6 357.4 178.9C357.5 178.5 357.7 178.2 358.1 178.1C359.7 177.6 366.9 175.4 366.9 175.4L352 162.6L336.6 157.4C336.6 157.4 332.5 168.6 327.1 168.5C321.7 168.4 313.3 179.4 312.4 185C311.5 190.6 318.3 193.2 312.4 196.1C306.5 199 308.4 206.6 305.8 211.8C303.5 216.6 295.9 212.2 292.2 213.2C285.6 214.9 287.2 224.8 279 225.7C277.2 225.9 275.4 225.6 273.7 225.7C272.1 225.8 270.5 226.3 269.1 227C268.4 227.4 267.8 227.8 267.4 228.5C265.9 231.4 271.1 235.2 268.9 237.6C266 237.9 263.6 240 260.8 241.1C254.5 243.7 247.4 241.1 240.7 239.7C234.8 238.5 228.7 238.3 222.6 238.3C218.2 238.3 213 238.6 214.6 242.2C214.7 242.3 214.8 242.4 215 242.5C216.2 243.4 217.2 244.7 217.7 246.1C218.1 246.5 218.4 246.9 218.6 247.4C219 248.4 218.6 249.4 218.1 250.3C217.1 254.7 211.4 256.8 204.8 257.8C204.7 258.1 204.8 258.3 204.9 258.6C200.1 259.5 195.3 259.5 190.4 259.5C188.6 259.5 186.6 259.5 184.9 259C176.9 259.3 164.5 260.4 157.9 256C151.6 251.8 152.3 245.4 144.3 242.8C139.8 241.3 140.4 237.7 138.2 234.4C135.1 229.5 130 231.2 127.6 226.3C126 223 120.8 223 118.8 219.9C117.7 218.1 117.9 215.8 118.3 213.8C118.4 213.3 118.5 212.8 118.9 212.5C119.3 212.1 119.9 212 120.3 211.7C121.2 211 121.1 209.7 121.4 208.6C122.4 205.5 126.6 205.2 127.9 202.4C121.4 197.6 111.2 194.6 112.5 184.2C113 180.1 99.8 178.1 96.1 172.2C92.4 166.3 85.2 175.9 79.6 163.7C74 151.6 50.4 154.2 48 154.2C45.5 154.2 41.2 166.3 35 167.9C31.2 168.9 33.8 173.1 36.4 176.9C37.2 176.7 38.1 176.8 38.9 177.2L39 177.3C40.1 177.1 41.2 177 42.2 177.4C44.2 178 45.2 179.7 45.9 181.6C46 182 46.1 182.4 46 182.7C46.5 183.1 46.9 183.7 47.1 184.3C47.4 185.1 47.2 186 46.8 186.8C46.4 187.5 45.6 188.1 44.9 188.3C44.8 188.3 44.7 188.3 44.6 188.4C44.5 188.5 44.5 188.5 44.4 188.6C43.3 189.5 42 189.4 40.8 188.9C40.4 188.7 39.9 188.5 39.5 188.2C38.9 189.3 37.7 190.3 35 190.8C28.8 192.1 27.3 199.6 28.8 204.2C29 204.8 29 205.3 28.9 205.8C31.3 205.8 33.8 206.1 36.1 206.1C42.4 206.4 42.5 216.1 36.1 215.9C35.8 215.9 35.4 215.9 35.1 215.9C34.5 217.3 33.4 218.4 31.9 218.9C30.5 219.4 29.1 220.2 27.8 221C28.2 224.9 29 229.5 28.5 233.5C29.2 233.6 29.9 233.8 30.4 234C32.5 234.7 34.3 236.3 35.3 238.3C36.3 237.7 37.4 237.6 38.6 238.2C39.5 238.7 40.1 239.7 40.2 240.8C40.4 240.9 40.6 240.9 40.9 241C41 240.9 41.2 240.9 41.3 240.8C41.7 240.6 42.1 240.5 42.5 240.5C42.9 240.5 43.4 240.6 43.7 240.8C44.1 240.9 44.4 241.2 44.7 241.5C44.8 241.6 45 241.8 45.1 242C45.2 242.1 45.4 242.2 45.5 242.3C45.9 242.7 46.2 243.2 46.3 243.7C46.3 244 46.4 244.3 46.4 244.6C46.4 245 46.3 245.5 46.1 245.8C46 246.2 45.7 246.5 45.4 246.8C45.1 247.1 44.8 247.3 44.4 247.5C44 247.7 43.6 247.8 43.2 247.8C43 247.8 42.8 247.8 42.6 247.7C42.2 248.3 41.6 248.7 40.9 248.8C39.1 249.1 37.2 249.1 35.6 248.3C34.9 248.5 34.1 248.5 33.3 248.4C32.8 248.3 32.3 248.2 31.8 248C30.7 248.7 29.5 249.2 28.2 249.5C28.4 252.9 28.2 256.5 28 259.8C28 260.2 28 260.6 28 261C30.1 261.7 32.1 263.1 34.1 264.5C34.8 265 35.3 265.7 35.6 266.4H35.7C37.4 266.3 38.6 266.5 40.1 267.2C42 268.1 42.1 270.9 40.8 272.3C40.4 272.6 40.1 273 39.7 273.3C39.6 274.7 38.7 276 37.3 276.3C36.8 276.4 36.4 276.5 35.9 276.6C34.8 277.5 33.4 278 31.8 278C31.7 278 31.7 278 31.6 278C31.2 279.4 30 280.5 28.5 280.4C28.3 280.4 28 280.4 27.8 280.4C27.9 280.4 27.1 280.8 27.4 280.6C27.1 280.9 27 281.1 26.6 281.6C25.5 283.2 24.4 284.6 22.7 285.5C22.1 285.8 21.5 285.9 20.9 285.9C19.6 287.6 18.5 289.8 18.5 289.8Z",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 289.8H381.4C381.4 289.8 381.5 289.4 381.5 288.9C380 288.3 378.8 287.3 378.2 286C377.2 285.8 376.7 285.8 375.4 285.6C374.5 285.5 373.7 284.7 373.3 283.8C370.8 281.9 369.1 278.5 367.6 276.4C366.6 276.2 365.6 276 364.7 275.7C364.7 275.7 364.7 275.7 364.6 275.7C363.1 276.6 361.5 277.2 359.6 277C357.7 276.9 355.7 275 356.5 272.9C357.3 271 358.4 269.4 360.6 268.9C361.4 268.7 362.2 268.8 363 268.7C363.1 268.7 363.2 268.7 363.3 268.7C363.3 268.7 363.3 268.7 363.4 268.6C363.3 268.6 363.1 268.8 363.2 268.5C364 267.2 365.3 266.8 366.4 267C370.4 265.6 372.1 265.7 372.1 261.4C372.1 260.8 372.2 260.2 372.4 259.6C372.4 259 372.4 258.5 372.4 257.9C372.5 255.9 373.9 252.4 373.1 251C372.1 249.4 369.6 248.3 368.4 246.5C368.3 246.4 368.3 246.2 368.2 246.1C367.3 245.9 366.4 245.4 365.7 244.8C364.8 245.1 363.7 244.9 362.8 243.9L361.2 243.6C360.7 243.9 360.1 244 359.5 244C358.2 245.8 355.2 246.5 354 244C351.9 239.5 353.1 233.6 359.2 234.4C359.9 234.5 360.6 234.8 361.2 235.2C362.2 235.1 363.3 235.2 364.3 235.4C365 235 365.9 234.7 366.7 234.7H370.6C370.6 234.6 370.6 234.5 370.7 234.4C370.9 232.8 370.7 231 370.7 229.4C370.7 227 370.7 224.4 371.7 222.2C371.6 221.9 371.5 221.7 371.4 221.5C367.3 220.7 360 221.1 358.3 220.7C357.2 220.4 356.6 219.8 356.3 219.1C355.9 218.7 355.5 218.2 355.3 217.7C354.8 216.4 354.5 215.1 354.4 213.7C354.3 212.7 355.1 211.3 356 210.9C356.5 210.7 357 210.4 357.5 210.3C358.1 209.6 358.8 209.1 359.6 208.7C360.4 207.8 361.6 207.2 363.1 207.2H363.4C364.5 206.8 365.6 206.2 366.6 205.4C368.2 204.1 369.6 202.5 371.9 202.8H372V190.8C365.8 190.7 359.5 188.7 355.9 183.3C354.6 181.3 355.8 179.6 357.4 178.9C357.5 178.5 357.7 178.2 358.1 178.1C359.7 177.6 366.9 175.4 366.9 175.4L352 162.6L336.6 157.4C336.6 157.4 332.5 168.6 327.1 168.5C321.7 168.4 313.3 179.4 312.4 185C311.5 190.6 318.3 193.2 312.4 196.1C306.5 199 308.4 206.6 305.8 211.8C303.5 216.6 295.9 212.2 292.2 213.2C285.6 214.9 287.2 224.8 279 225.7C277.2 225.9 275.4 225.6 273.7 225.7C272.1 225.8 270.5 226.3 269.1 227C268.4 227.4 267.8 227.8 267.4 228.5C265.9 231.4 271.1 235.2 268.9 237.6C266 237.9 263.6 240 260.8 241.1C254.5 243.7 247.4 241.1 240.7 239.7C234.8 238.5 228.7 238.3 222.6 238.3C218.2 238.3 213 238.6 214.6 242.2C214.7 242.3 214.8 242.4 215 242.5C216.2 243.4 217.2 244.7 217.7 246.1C218.1 246.5 218.4 246.9 218.6 247.4C219 248.4 218.6 249.4 218.1 250.3C217.1 254.7 211.4 256.8 204.8 257.8C204.7 258.1 204.8 258.3 204.9 258.6C200.1 259.5 195.3 259.5 190.4 259.5C188.6 259.5 186.6 259.5 184.9 259C176.9 259.3 164.5 260.4 157.9 256C151.6 251.8 152.3 245.4 144.3 242.8C139.8 241.3 140.4 237.7 138.2 234.4C135.1 229.5 130 231.2 127.6 226.3C126 223 120.8 223 118.8 219.9C117.7 218.1 117.9 215.8 118.3 213.8C118.4 213.3 118.5 212.8 118.9 212.5C119.3 212.1 119.9 212 120.3 211.7C121.2 211 121.1 209.7 121.4 208.6C122.4 205.5 126.6 205.2 127.9 202.4C121.4 197.6 111.2 194.6 112.5 184.2C113 180.1 99.8 178.1 96.1 172.2C92.4 166.3 85.2 175.9 79.6 163.7C74 151.6 50.4 154.2 48 154.2C45.5 154.2 41.2 166.3 35 167.9C31.2 168.9 33.8 173.1 36.4 176.9C37.2 176.7 38.1 176.8 38.9 177.2L39 177.3C40.1 177.1 41.2 177 42.2 177.4C44.2 178 45.2 179.7 45.9 181.6C46 182 46.1 182.4 46 182.7C46.5 183.1 46.9 183.7 47.1 184.3C47.4 185.1 47.2 186 46.8 186.8C46.4 187.5 45.6 188.1 44.9 188.3C44.8 188.3 44.7 188.3 44.6 188.4C44.5 188.5 44.5 188.5 44.4 188.6C43.3 189.5 42 189.4 40.8 188.9C40.4 188.7 39.9 188.5 39.5 188.2C38.9 189.3 37.7 190.3 35 190.8C28.8 192.1 27.3 199.6 28.8 204.2C29 204.8 29 205.3 28.9 205.8C31.3 205.8 33.8 206.1 36.1 206.1C42.4 206.4 42.5 216.1 36.1 215.9C35.8 215.9 35.4 215.9 35.1 215.9C34.5 217.3 33.4 218.4 31.9 218.9C30.5 219.4 29.1 220.2 27.8 221C28.2 224.9 29 229.5 28.5 233.5C29.2 233.6 29.9 233.8 30.4 234C32.5 234.7 34.3 236.3 35.3 238.3C36.3 237.7 37.4 237.6 38.6 238.2C39.5 238.7 40.1 239.7 40.2 240.8C40.4 240.9 40.6 240.9 40.9 241C41 240.9 41.2 240.9 41.3 240.8C41.7 240.6 42.1 240.5 42.5 240.5C42.9 240.5 43.4 240.6 43.7 240.8C44.1 240.9 44.4 241.2 44.7 241.5C44.8 241.6 45 241.8 45.1 242C45.2 242.1 45.4 242.2 45.5 242.3C45.9 242.7 46.2 243.2 46.3 243.7C46.3 244 46.4 244.3 46.4 244.6C46.4 245 46.3 245.5 46.1 245.8C46 246.2 45.7 246.5 45.4 246.8C45.1 247.1 44.8 247.3 44.4 247.5C44 247.7 43.6 247.8 43.2 247.8C43 247.8 42.8 247.8 42.6 247.7C42.2 248.3 41.6 248.7 40.9 248.8C39.1 249.1 37.2 249.1 35.6 248.3C34.9 248.5 34.1 248.5 33.3 248.4C32.8 248.3 32.3 248.2 31.8 248C30.7 248.7 29.5 249.2 28.2 249.5C28.4 252.9 28.2 256.5 28 259.8C28 260.2 28 260.6 28 261C30.1 261.7 32.1 263.1 34.1 264.5C34.8 265 35.3 265.7 35.6 266.4H35.7C37.4 266.3 38.6 266.5 40.1 267.2C42 268.1 42.1 270.9 40.8 272.3C40.4 272.6 40.1 273 39.7 273.3C39.6 274.7 38.7 276 37.3 276.3C36.8 276.4 36.4 276.5 35.9 276.6C34.8 277.5 33.4 278 31.8 278C31.7 278 31.7 278 31.6 278C31.2 279.4 30 280.5 28.5 280.4C28.3 280.4 28 280.4 27.8 280.4C27.9 280.4 27.1 280.8 27.4 280.6C27.1 280.9 27 281.1 26.6 281.6C25.5 283.2 24.4 284.6 22.7 285.5C22.1 285.8 21.5 285.9 20.9 285.9C19.6 287.6 18.5 289.8 18.5 289.8Z",
    fill: "url(#paint16_linear_1945_3664)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M371.9 278.201H336.6V290.201H371.9V278.201Z",
    fill: "url(#paint17_linear_1945_3664)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M333.4 278.201H298.1V290.201H333.4V278.201Z",
    fill: "url(#paint18_linear_1945_3664)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M294.9 278.201H259.6V290.201H294.9V278.201Z",
    fill: "url(#paint19_linear_1945_3664)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M256.4 278.201H221.1V290.201H256.4V278.201Z",
    fill: "url(#paint20_linear_1945_3664)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M217.9 278.201H182.6V290.201H217.9V278.201Z",
    fill: "url(#paint21_linear_1945_3664)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M179.4 278.201H144.1V290.201H179.4V278.201Z",
    fill: "url(#paint22_linear_1945_3664)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 278.201H105.6V290.201H140.9V278.201Z",
    fill: "url(#paint23_linear_1945_3664)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M102.4 278.201H67.1001V290.201H102.4V278.201Z",
    fill: "url(#paint24_linear_1945_3664)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9001 278.201H28.6001V290.201H63.9001V278.201Z",
    fill: "url(#paint25_linear_1945_3664)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M371.9 249.5H336.6V261.5H371.9V249.5Z",
    fill: "url(#paint26_linear_1945_3664)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M333.4 249.5H298.1V261.5H333.4V249.5Z",
    fill: "url(#paint27_linear_1945_3664)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M294.9 249.5H259.6V261.5H294.9V249.5Z",
    fill: "url(#paint28_linear_1945_3664)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M256.4 249.5H221.1V261.5H256.4V249.5Z",
    fill: "url(#paint29_linear_1945_3664)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M179.4 249.5H144.1V261.5H179.4V249.5Z",
    fill: "url(#paint30_linear_1945_3664)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 249.5H105.6V261.5H140.9V249.5Z",
    fill: "url(#paint31_linear_1945_3664)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M102.4 249.5H67.1001V261.5H102.4V249.5Z",
    fill: "url(#paint32_linear_1945_3664)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9001 249.5H28.6001V261.5H63.9001V249.5Z",
    fill: "url(#paint33_linear_1945_3664)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M371.9 220.701H336.6V232.701H371.9V220.701Z",
    fill: "url(#paint34_linear_1945_3664)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M333.4 220.701H298.1V232.701H333.4V220.701Z",
    fill: "url(#paint35_linear_1945_3664)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M294.9 220.701H259.6V232.701H294.9V220.701Z",
    fill: "url(#paint36_linear_1945_3664)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 220.701H105.6V232.701H140.9V220.701Z",
    fill: "url(#paint37_linear_1945_3664)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M102.4 220.701H67.1001V232.701H102.4V220.701Z",
    fill: "url(#paint38_linear_1945_3664)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9001 220.701H28.6001V232.701H63.9001V220.701Z",
    fill: "url(#paint39_linear_1945_3664)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M371.9 192H336.6V204H371.9V192Z",
    fill: "url(#paint40_linear_1945_3664)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M333.4 192H298.1V204H333.4V192Z",
    fill: "url(#paint41_linear_1945_3664)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M106.959 188.939L104.764 200.736L139.467 207.193L141.662 195.395L106.959 188.939Z",
    fill: "url(#paint42_linear_1945_3664)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M102.4 192H67.1001V204H102.4V192Z",
    fill: "url(#paint43_linear_1945_3664)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9001 192H28.6001V204H63.9001V192Z",
    fill: "url(#paint44_linear_1945_3664)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M352.7 263.9H317.4V275.9H352.7V263.9Z",
    fill: "url(#paint45_linear_1945_3664)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M314.2 263.9H278.9V275.9H314.2V263.9Z",
    fill: "url(#paint46_linear_1945_3664)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M275.7 263.9H240.4V275.9H275.7V263.9Z",
    fill: "url(#paint47_linear_1945_3664)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M237.2 263.9H201.9V275.9H237.2V263.9Z",
    fill: "url(#paint48_linear_1945_3664)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M198.7 263.9H163.4V275.9H198.7V263.9Z",
    fill: "url(#paint49_linear_1945_3664)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M160.2 263.9H124.9V275.9H160.2V263.9Z",
    fill: "url(#paint50_linear_1945_3664)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M121.6 263.9H86.3V275.9H121.6V263.9Z",
    fill: "url(#paint51_linear_1945_3664)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1001 263.9H47.8V275.9H83.1001V263.9Z",
    fill: "url(#paint52_linear_1945_3664)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M352.7 235.102H317.4V247.102H352.7V235.102Z",
    fill: "url(#paint53_linear_1945_3664)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M314.2 235.102H278.9V247.102H314.2V235.102Z",
    fill: "url(#paint54_linear_1945_3664)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M275.7 235.102H240.4V247.102H275.7V235.102Z",
    fill: "url(#paint55_linear_1945_3664)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M237.2 235.102H201.9V247.102H237.2V235.102Z",
    fill: "url(#paint56_linear_1945_3664)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M160.2 235.102H124.9V247.102H160.2V235.102Z",
    fill: "url(#paint57_linear_1945_3664)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M121.6 235.102H86.3V247.102H121.6V235.102Z",
    fill: "url(#paint58_linear_1945_3664)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1001 235.102H47.8V247.102H83.1001V235.102Z",
    fill: "url(#paint59_linear_1945_3664)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M352.7 206.301H317.4V218.301H352.7V206.301Z",
    fill: "url(#paint60_linear_1945_3664)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M314.2 206.301H278.9V218.301H314.2V206.301Z",
    fill: "url(#paint61_linear_1945_3664)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M121.6 206.301H86.3V218.301H121.6V206.301Z",
    fill: "url(#paint62_linear_1945_3664)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1001 206.301H47.8V218.301H83.1001V206.301Z",
    fill: "url(#paint63_linear_1945_3664)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M366.9 163.201H331.6V175.201H366.9V163.201Z",
    fill: "url(#paint64_linear_1945_3664)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M322.483 160.175L294.391 181.553L301.658 191.102L329.75 169.725L322.483 160.175Z",
    fill: "url(#paint65_linear_1945_3664)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M102.4 163.201H67.1001V175.201H102.4V163.201Z",
    fill: "url(#paint66_linear_1945_3664)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9001 163.201H28.6001V175.201H63.9001V163.201Z",
    fill: "url(#paint67_linear_1945_3664)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M352.7 177.602H317.4V189.602H352.7V177.602Z",
    fill: "url(#paint68_linear_1945_3664)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M120.988 176.039L85.833 179.25L86.9247 191.201L122.08 187.989L120.988 176.039Z",
    fill: "url(#paint69_linear_1945_3664)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1001 177.602H47.8V189.602H83.1001V177.602Z",
    fill: "url(#paint70_linear_1945_3664)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M318.094 147.184L316.887 159.123L352.007 162.674L353.214 150.735L318.094 147.184Z",
    fill: "url(#paint71_linear_1945_3664)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1001 148.801H47.8V160.801H83.1001V148.801Z",
    fill: "url(#paint72_linear_1945_3664)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.9 278.201H336.6V290.201H371.9V278.201Z",
    fill: "url(#paint73_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4 278.201H298.1V290.201H333.4V278.201Z",
    fill: "url(#paint74_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.9 278.201H259.6V290.201H294.9V278.201Z",
    fill: "url(#paint75_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.4 278.201H221.1V290.201H256.4V278.201Z",
    fill: "url(#paint76_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.9 278.201H182.6V290.201H217.9V278.201Z",
    fill: "url(#paint77_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4 278.201H144.1V290.201H179.4V278.201Z",
    fill: "url(#paint78_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9 278.201H105.6V290.201H140.9V278.201Z",
    fill: "url(#paint79_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.4 278.201H67.1001V290.201H102.4V278.201Z",
    fill: "url(#paint80_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9001 278.201H28.6001V290.201H63.9001V278.201Z",
    fill: "url(#paint81_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.9 249.5H336.6V261.5H371.9V249.5Z",
    fill: "url(#paint82_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4 249.5H298.1V261.5H333.4V249.5Z",
    fill: "url(#paint83_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.9 249.5H259.6V261.5H294.9V249.5Z",
    fill: "url(#paint84_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.4 249.5H221.1V261.5H256.4V249.5Z",
    fill: "url(#paint85_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4 249.5H144.1V261.5H179.4V249.5Z",
    fill: "url(#paint86_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9 249.5H105.6V261.5H140.9V249.5Z",
    fill: "url(#paint87_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.4 249.5H67.1001V261.5H102.4V249.5Z",
    fill: "url(#paint88_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9001 249.5H28.6001V261.5H63.9001V249.5Z",
    fill: "url(#paint89_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.9 220.701H336.6V232.701H371.9V220.701Z",
    fill: "url(#paint90_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4 220.701H298.1V232.701H333.4V220.701Z",
    fill: "url(#paint91_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.9 220.701H259.6V232.701H294.9V220.701Z",
    fill: "url(#paint92_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9 220.701H105.6V232.701H140.9V220.701Z",
    fill: "url(#paint93_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.4 220.701H67.1001V232.701H102.4V220.701Z",
    fill: "url(#paint94_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9001 220.701H28.6001V232.701H63.9001V220.701Z",
    fill: "url(#paint95_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.9 192H336.6V204H371.9V192Z",
    fill: "url(#paint96_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4 192H298.1V204H333.4V192Z",
    fill: "url(#paint97_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.959 188.939L104.764 200.736L139.467 207.193L141.662 195.395L106.959 188.939Z",
    fill: "url(#paint98_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.4 192H67.1001V204H102.4V192Z",
    fill: "url(#paint99_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9001 192H28.6001V204H63.9001V192Z",
    fill: "url(#paint100_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.7 263.9H317.4V275.9H352.7V263.9Z",
    fill: "url(#paint101_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2 263.9H278.9V275.9H314.2V263.9Z",
    fill: "url(#paint102_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.7 263.9H240.4V275.9H275.7V263.9Z",
    fill: "url(#paint103_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.2 263.9H201.9V275.9H237.2V263.9Z",
    fill: "url(#paint104_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.7 263.9H163.4V275.9H198.7V263.9Z",
    fill: "url(#paint105_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2 263.9H124.9V275.9H160.2V263.9Z",
    fill: "url(#paint106_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6 263.9H86.3V275.9H121.6V263.9Z",
    fill: "url(#paint107_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1001 263.9H47.8V275.9H83.1001V263.9Z",
    fill: "url(#paint108_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.7 235.102H317.4V247.102H352.7V235.102Z",
    fill: "url(#paint109_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2 235.102H278.9V247.102H314.2V235.102Z",
    fill: "url(#paint110_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.7 235.102H240.4V247.102H275.7V235.102Z",
    fill: "url(#paint111_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.2 235.102H201.9V247.102H237.2V235.102Z",
    fill: "url(#paint112_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2 235.102H124.9V247.102H160.2V235.102Z",
    fill: "url(#paint113_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6 235.102H86.3V247.102H121.6V235.102Z",
    fill: "url(#paint114_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1001 235.102H47.8V247.102H83.1001V235.102Z",
    fill: "url(#paint115_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.7 206.301H317.4V218.301H352.7V206.301Z",
    fill: "url(#paint116_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2 206.301H278.9V218.301H314.2V206.301Z",
    fill: "url(#paint117_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6 206.301H86.3V218.301H121.6V206.301Z",
    fill: "url(#paint118_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1001 206.301H47.8V218.301H83.1001V206.301Z",
    fill: "url(#paint119_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.9 163.201H331.6V175.201H366.9V163.201Z",
    fill: "url(#paint120_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.483 160.175L294.391 181.553L301.658 191.102L329.75 169.725L322.483 160.175Z",
    fill: "url(#paint121_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.4 163.201H67.1001V175.201H102.4V163.201Z",
    fill: "url(#paint122_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9001 163.201H28.6001V175.201H63.9001V163.201Z",
    fill: "url(#paint123_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.7 177.602H317.4V189.602H352.7V177.602Z",
    fill: "url(#paint124_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.988 176.039L85.833 179.25L86.9247 191.201L122.08 187.989L120.988 176.039Z",
    fill: "url(#paint125_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1001 177.602H47.8V189.602H83.1001V177.602Z",
    fill: "url(#paint126_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.094 147.184L316.887 159.123L352.007 162.674L353.214 150.735L318.094 147.184Z",
    fill: "url(#paint127_linear_1945_3664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1001 148.801H47.8V160.801H83.1001V148.801Z",
    fill: "url(#paint128_linear_1945_3664)"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M247.5 292.601C246.8 291.801 245.8 290.801 244.5 290.401C242.2 289.701 242.3 287.301 240 286.301C237.7 285.301 236.5 286.401 229.5 286.101C222.6 285.801 226.7 285.101 218 283.301C209.3 281.501 214.3 283.201 210.7 282.501C207.1 281.801 204.9 281.601 201.5 280.601C198.2 279.601 195.4 278.901 192.5 276.001C189.6 273.001 186.7 274.701 184.1 275.001C181.5 275.301 177 276.001 164.9 277.701C152.8 279.501 161.2 281.001 158.1 283.701C154.9 286.301 149.4 283.201 146.8 285.001C144.2 286.801 137.6 289.001 133.6 288.801C130.3 288.601 128.7 291.601 128.2 292.701H247.5V292.601Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M247.5 292.601C246.8 291.801 245.8 290.801 244.5 290.401C242.2 289.701 242.3 287.301 240 286.301C237.7 285.301 236.5 286.401 229.5 286.101C222.6 285.801 226.7 285.101 218 283.301C209.3 281.501 214.3 283.201 210.7 282.501C207.1 281.801 204.9 281.601 201.5 280.601C198.2 279.601 195.4 278.901 192.5 276.001C189.6 273.001 186.7 274.701 184.1 275.001C181.5 275.301 177 276.001 164.9 277.701C152.8 279.501 161.2 281.001 158.1 283.701C154.9 286.301 149.4 283.201 146.8 285.001C144.2 286.801 137.6 289.001 133.6 288.801C130.3 288.601 128.7 291.601 128.2 292.701H247.5V292.601Z",
    fill: "url(#paint129_linear_1945_3664)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M160.2 279.4L165 286.4L197.2 278.6L192.3 271.5L160.2 279.4Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M160.2 279.4L165 286.4L197.2 278.6L192.3 271.5L160.2 279.4Z",
    fill: "url(#paint130_linear_1945_3664)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M192.9 286.4L201.9 278.5L206.9 281.4L213.4 282.3L205.2 290.8L192.9 286.4Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M192.9 286.4L201.9 278.5L206.9 281.4L213.4 282.3L205.2 290.8L192.9 286.4Z",
    fill: "url(#paint131_linear_1945_3664)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M120.7 292.6C119.4 291.3 117.3 289.4 116.4 289.2C115 289 114.4 288.8 112 289.2C109.6 289.6 109.8 287.3 107.6 286.5C105.4 285.7 101.3 284.1 98.9001 283.1C96.5001 282.1 95.1001 283.1 93.6001 284C92.0001 284.9 88.9001 284.3 84.7001 286.5C80.6001 288.7 77.4001 290.4 74.6001 290.8C73.1001 291.1 71.3001 291.9 70.1001 292.6H120.7Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M120.7 292.6C119.4 291.3 117.3 289.4 116.4 289.2C115 289 114.4 288.8 112 289.2C109.6 289.6 109.8 287.3 107.6 286.5C105.4 285.7 101.3 284.1 98.9001 283.1C96.5001 282.1 95.1001 283.1 93.6001 284C92.0001 284.9 88.9001 284.3 84.7001 286.5C80.6001 288.7 77.4001 290.4 74.6001 290.8C73.1001 291.1 71.3001 291.9 70.1001 292.6H120.7Z",
    fill: "url(#paint132_linear_1945_3664)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.578 21.9453C178.224 21.9815 177.864 22 177.5 22C171.701 22 167 17.299 167 11.5C167 5.70101 171.701 1 177.5 1C182.092 1 185.996 3.94798 187.422 8.0547C187.776 8.01853 188.136 8 188.5 8C194.299 8 199 12.701 199 18.5C199 23.1181 196.019 27.0398 191.876 28.4456C191.957 28.7838 192 29.1369 192 29.5C192 31.1109 191.154 32.5241 189.881 33.3191C189.958 33.5317 190 33.7609 190 34C190 35.1046 189.105 36 188 36C186.895 36 186 35.1046 186 34C186 33.9151 186.005 33.8315 186.016 33.7494C184.26 33.1361 183 31.4651 183 29.5C183 28.8495 183.138 28.2312 183.386 27.6728C181.157 26.4271 179.428 24.3918 178.578 21.9453Z",
    fill: "url(#paint133_linear_1945_3664)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1945_3664",
    x: 17,
    y: 94,
    width: 289.4,
    height: 164.301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.766562 0 0 0 0 0.766562 0 0 0 0 0.825 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1945_3664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1945_3664",
    x1: 193.2,
    y1: 40.1992,
    x2: 193.183,
    y2: 48.8532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1945_3664",
    x1: 367.3,
    y1: 33.9993,
    x2: 361.739,
    y2: 51.2014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1945_3664",
    x1: 251,
    y1: 33.9993,
    x2: 245.439,
    y2: 51.2014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1945_3664",
    x1: 134.7,
    y1: 33.9993,
    x2: 129.139,
    y2: 51.2015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1945_3664",
    x1: 18.5,
    y1: 34.0031,
    x2: 12.9941,
    y2: 51.1285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1945_3664",
    x1: 308.022,
    y1: -1.35299,
    x2: 300.858,
    y2: 52.2297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1945_3664",
    x1: 193,
    y1: 70,
    x2: 192.983,
    y2: 78.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1945_3664",
    x1: 367.3,
    y1: 63.9993,
    x2: 361.739,
    y2: 81.2014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1945_3664",
    x1: 251,
    y1: 63.9993,
    x2: 245.439,
    y2: 81.2014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1945_3664",
    x1: 134.7,
    y1: 63.9993,
    x2: 129.139,
    y2: 81.2015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1945_3664",
    x1: 18.5,
    y1: 64.0031,
    x2: 12.9941,
    y2: 81.1285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1945_3664",
    x1: 131.5,
    y1: 97,
    x2: 115.538,
    y2: 189.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1945_3664",
    x1: 251,
    y1: 94.9993,
    x2: 245.439,
    y2: 112.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1945_3664",
    x1: 134.7,
    y1: 94.9993,
    x2: 129.139,
    y2: 112.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1945_3664",
    x1: 18.5,
    y1: 95.0031,
    x2: 12.9941,
    y2: 112.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1945_3664",
    x1: 308.826,
    y1: 151.761,
    x2: 291.624,
    y2: 146.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1945_3664",
    x1: 256.65,
    y1: 240.406,
    x2: 273.049,
    y2: 120.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9811,
    stopColor: "#E3E3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1945_3664",
    x1: 354.25,
    y1: 278.201,
    x2: 345.306,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1945_3664",
    x1: 315.75,
    y1: 278.201,
    x2: 306.806,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1945_3664",
    x1: 277.25,
    y1: 278.201,
    x2: 268.306,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1945_3664",
    x1: 238.75,
    y1: 278.201,
    x2: 229.806,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1945_3664",
    x1: 200.25,
    y1: 278.201,
    x2: 191.306,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1945_3664",
    x1: 161.75,
    y1: 278.201,
    x2: 152.806,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1945_3664",
    x1: 123.25,
    y1: 278.201,
    x2: 114.306,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1945_3664",
    x1: 84.7501,
    y1: 278.201,
    x2: 75.8063,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1945_3664",
    x1: 46.2501,
    y1: 278.201,
    x2: 37.3063,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1945_3664",
    x1: 354.25,
    y1: 249.5,
    x2: 345.306,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1945_3664",
    x1: 315.75,
    y1: 249.5,
    x2: 306.806,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1945_3664",
    x1: 277.25,
    y1: 249.5,
    x2: 268.306,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1945_3664",
    x1: 238.75,
    y1: 249.5,
    x2: 229.806,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1945_3664",
    x1: 161.75,
    y1: 249.5,
    x2: 152.806,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1945_3664",
    x1: 123.25,
    y1: 249.5,
    x2: 114.306,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1945_3664",
    x1: 84.7501,
    y1: 249.5,
    x2: 75.8063,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1945_3664",
    x1: 46.2501,
    y1: 249.5,
    x2: 37.3063,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1945_3664",
    x1: 354.25,
    y1: 220.701,
    x2: 345.306,
    y2: 240.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1945_3664",
    x1: 315.75,
    y1: 220.701,
    x2: 306.806,
    y2: 240.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1945_3664",
    x1: 277.25,
    y1: 220.701,
    x2: 268.306,
    y2: 240.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1945_3664",
    x1: 123.25,
    y1: 220.701,
    x2: 114.306,
    y2: 240.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1945_3664",
    x1: 84.7501,
    y1: 220.701,
    x2: 75.8063,
    y2: 240.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1945_3664",
    x1: 46.2501,
    y1: 220.701,
    x2: 37.3063,
    y2: 240.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1945_3664",
    x1: 354.25,
    y1: 192,
    x2: 345.306,
    y2: 211.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1945_3664",
    x1: 315.75,
    y1: 192,
    x2: 306.806,
    y2: 211.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1945_3664",
    x1: 105.861,
    y1: 194.838,
    x2: 106.926,
    y2: 211.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1945_3664",
    x1: 84.7501,
    y1: 192,
    x2: 75.8063,
    y2: 211.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1945_3664",
    x1: 46.2501,
    y1: 192,
    x2: 37.3063,
    y2: 211.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1945_3664",
    x1: 335.05,
    y1: 263.9,
    x2: 326.106,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1945_3664",
    x1: 296.55,
    y1: 263.9,
    x2: 287.606,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1945_3664",
    x1: 258.05,
    y1: 263.9,
    x2: 249.106,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1945_3664",
    x1: 219.55,
    y1: 263.9,
    x2: 210.606,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1945_3664",
    x1: 181.05,
    y1: 263.9,
    x2: 172.106,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1945_3664",
    x1: 142.55,
    y1: 263.9,
    x2: 133.606,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1945_3664",
    x1: 103.95,
    y1: 263.9,
    x2: 95.0063,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1945_3664",
    x1: 65.4501,
    y1: 263.9,
    x2: 56.5063,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1945_3664",
    x1: 335.05,
    y1: 235.102,
    x2: 326.106,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1945_3664",
    x1: 296.55,
    y1: 235.102,
    x2: 287.606,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1945_3664",
    x1: 258.05,
    y1: 235.102,
    x2: 249.106,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1945_3664",
    x1: 219.55,
    y1: 235.102,
    x2: 210.606,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1945_3664",
    x1: 142.55,
    y1: 235.102,
    x2: 133.606,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1945_3664",
    x1: 103.95,
    y1: 235.102,
    x2: 95.0063,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1945_3664",
    x1: 65.4501,
    y1: 235.102,
    x2: 56.5063,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1945_3664",
    x1: 335.05,
    y1: 206.301,
    x2: 326.106,
    y2: 225.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1945_3664",
    x1: 296.55,
    y1: 206.301,
    x2: 287.606,
    y2: 225.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1945_3664",
    x1: 103.95,
    y1: 206.301,
    x2: 95.0063,
    y2: 225.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1945_3664",
    x1: 65.4501,
    y1: 206.301,
    x2: 56.5063,
    y2: 225.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1945_3664",
    x1: 349.25,
    y1: 163.201,
    x2: 340.306,
    y2: 182.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1945_3664",
    x1: 308.437,
    y1: 170.864,
    x2: 313.126,
    y2: 191.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1945_3664",
    x1: 84.7501,
    y1: 163.201,
    x2: 75.8063,
    y2: 182.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1945_3664",
    x1: 46.2501,
    y1: 163.201,
    x2: 37.3063,
    y2: 182.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1945_3664",
    x1: 335.05,
    y1: 177.602,
    x2: 326.106,
    y2: 197.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1945_3664",
    x1: 103.411,
    y1: 177.644,
    x2: 96.2771,
    y2: 197.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1945_3664",
    x1: 65.4501,
    y1: 177.602,
    x2: 56.5063,
    y2: 197.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1945_3664",
    x1: 317.491,
    y1: 153.154,
    x2: 319.957,
    y2: 169.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1945_3664",
    x1: 65.4501,
    y1: 148.801,
    x2: 56.5063,
    y2: 168.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1945_3664",
    x1: 354.25,
    y1: 278.201,
    x2: 345.306,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1945_3664",
    x1: 315.75,
    y1: 278.201,
    x2: 306.806,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1945_3664",
    x1: 277.25,
    y1: 278.201,
    x2: 268.306,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1945_3664",
    x1: 238.75,
    y1: 278.201,
    x2: 229.806,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1945_3664",
    x1: 200.25,
    y1: 278.201,
    x2: 191.306,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1945_3664",
    x1: 161.75,
    y1: 278.201,
    x2: 152.806,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1945_3664",
    x1: 123.25,
    y1: 278.201,
    x2: 114.306,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1945_3664",
    x1: 84.7501,
    y1: 278.201,
    x2: 75.8063,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1945_3664",
    x1: 46.2501,
    y1: 278.201,
    x2: 37.3063,
    y2: 297.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1945_3664",
    x1: 354.25,
    y1: 249.5,
    x2: 345.306,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1945_3664",
    x1: 315.75,
    y1: 249.5,
    x2: 306.806,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1945_3664",
    x1: 277.25,
    y1: 249.5,
    x2: 268.306,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1945_3664",
    x1: 238.75,
    y1: 249.5,
    x2: 229.806,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1945_3664",
    x1: 161.75,
    y1: 249.5,
    x2: 152.806,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1945_3664",
    x1: 123.25,
    y1: 249.5,
    x2: 114.306,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1945_3664",
    x1: 84.7501,
    y1: 249.5,
    x2: 75.8063,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1945_3664",
    x1: 46.2501,
    y1: 249.5,
    x2: 37.3063,
    y2: 268.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1945_3664",
    x1: 354.25,
    y1: 220.701,
    x2: 345.306,
    y2: 240.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1945_3664",
    x1: 315.75,
    y1: 220.701,
    x2: 306.806,
    y2: 240.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1945_3664",
    x1: 277.25,
    y1: 220.701,
    x2: 268.306,
    y2: 240.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1945_3664",
    x1: 123.25,
    y1: 220.701,
    x2: 114.306,
    y2: 240.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1945_3664",
    x1: 84.7501,
    y1: 220.701,
    x2: 75.8063,
    y2: 240.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1945_3664",
    x1: 46.2501,
    y1: 220.701,
    x2: 37.3063,
    y2: 240.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1945_3664",
    x1: 354.25,
    y1: 192,
    x2: 345.306,
    y2: 211.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1945_3664",
    x1: 315.75,
    y1: 192,
    x2: 306.806,
    y2: 211.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1945_3664",
    x1: 105.861,
    y1: 194.838,
    x2: 106.926,
    y2: 211.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1945_3664",
    x1: 84.7501,
    y1: 192,
    x2: 75.8063,
    y2: 211.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1945_3664",
    x1: 46.2501,
    y1: 192,
    x2: 37.3063,
    y2: 211.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1945_3664",
    x1: 335.05,
    y1: 263.9,
    x2: 326.106,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1945_3664",
    x1: 296.55,
    y1: 263.9,
    x2: 287.606,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1945_3664",
    x1: 258.05,
    y1: 263.9,
    x2: 249.106,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1945_3664",
    x1: 219.55,
    y1: 263.9,
    x2: 210.606,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1945_3664",
    x1: 181.05,
    y1: 263.9,
    x2: 172.106,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1945_3664",
    x1: 142.55,
    y1: 263.9,
    x2: 133.606,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1945_3664",
    x1: 103.95,
    y1: 263.9,
    x2: 95.0063,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1945_3664",
    x1: 65.4501,
    y1: 263.9,
    x2: 56.5063,
    y2: 283.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1945_3664",
    x1: 335.05,
    y1: 235.102,
    x2: 326.106,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1945_3664",
    x1: 296.55,
    y1: 235.102,
    x2: 287.606,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1945_3664",
    x1: 258.05,
    y1: 235.102,
    x2: 249.106,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1945_3664",
    x1: 219.55,
    y1: 235.102,
    x2: 210.606,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_1945_3664",
    x1: 142.55,
    y1: 235.102,
    x2: 133.606,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_1945_3664",
    x1: 103.95,
    y1: 235.102,
    x2: 95.0063,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1945_3664",
    x1: 65.4501,
    y1: 235.102,
    x2: 56.5063,
    y2: 254.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_1945_3664",
    x1: 335.05,
    y1: 206.301,
    x2: 326.106,
    y2: 225.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_1945_3664",
    x1: 296.55,
    y1: 206.301,
    x2: 287.606,
    y2: 225.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1945_3664",
    x1: 103.95,
    y1: 206.301,
    x2: 95.0063,
    y2: 225.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_1945_3664",
    x1: 65.4501,
    y1: 206.301,
    x2: 56.5063,
    y2: 225.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_1945_3664",
    x1: 349.25,
    y1: 163.201,
    x2: 340.306,
    y2: 182.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_1945_3664",
    x1: 308.437,
    y1: 170.864,
    x2: 313.126,
    y2: 191.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_1945_3664",
    x1: 84.7501,
    y1: 163.201,
    x2: 75.8063,
    y2: 182.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_1945_3664",
    x1: 46.2501,
    y1: 163.201,
    x2: 37.3063,
    y2: 182.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1945_3664",
    x1: 335.05,
    y1: 177.602,
    x2: 326.106,
    y2: 197.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_1945_3664",
    x1: 103.411,
    y1: 177.644,
    x2: 96.2771,
    y2: 197.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1945_3664",
    x1: 65.4501,
    y1: 177.602,
    x2: 56.5063,
    y2: 197.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1945_3664",
    x1: 317.491,
    y1: 153.154,
    x2: 319.957,
    y2: 169.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_1945_3664",
    x1: 65.4501,
    y1: 148.801,
    x2: 56.5063,
    y2: 168.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_1945_3664",
    x1: 206.468,
    y1: 285.991,
    x2: 207.403,
    y2: 269.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9811,
    stopColor: "#E3E3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_1945_3664",
    x1: 178.7,
    y1: 271.5,
    x2: 166.407,
    y2: 294.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_1945_3664",
    x1: 203.15,
    y1: 278.5,
    x2: 191.32,
    y2: 293.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_1945_3664",
    x1: 103.297,
    y1: 288.994,
    x2: 103.932,
    y2: 280.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9811,
    stopColor: "#E3E3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_1945_3664",
    x1: 183,
    y1: 1,
    x2: 183,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485447,
    stopColor: "#E5E5F0",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4EF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.dd2d6c0602dd5a40eff3402216dc32e9.svg";
export { ForwardRef as ReactComponent };